d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
        <v-card class="pa-0">
          <v-card-text class="pa-0 pt-5">
            <p class="text-center subheading">Opravdu chcete smazat drobný prodej?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="remove" :loading="sending">Smazat</v-btn>
            <v-btn color="grey" flat @click="dialogRemove=false;" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="1400px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="pa-0">
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <h2 v-if="!editMode">Nový drobný prodej</h2>
                <h2 v-else>Upravit drobný prodej</h2>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0" >
            <v-form ref="createForm" lazy-validation v-model="valid">
              <v-layout row wrap :class="{'px-2' : $vuetify.breakpoint.smAndUp}">
                <v-flex xs12 sm6>
                  <meny v-model="newItem.mena_id" @changed="(e) => { newItem.mena = e; }" :disabled="editMode"></meny>
                </v-flex>
                <v-flex xs12 sm6>
                  <sklady v-model="newItem.sklad_id" :rules="rulesRequired" :disabled="editMode"></sklady>
                </v-flex>
              </v-layout>
              <v-card color="grey lighten-4 mt-3" :class="{'mx-3 mt-4' : $vuetify.breakpoint.smAndUp}" v-if="newItem.mena != null">
                <h4 class="mx-0">Produkty v objednávce:</h4>
                <v-data-table
                  :headers="newHeaders"
                  :items="newItems"
                  :pagination.sync="pagination"
                  :total-items="pagination.totalItems"
                  :rows-per-page-items="[25, 50, 100, 200]"
                  class="mt-2"
                  item-key="produkt_id"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</router-link>
                      </td>
                      <td class="text-xs-right">
                        <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id">
                          <v-text-field
                            v-model="cena.prodejni_cena"
                            :suffix="cena.mena.zkratka"
                            type="number"
                            @input="(e) => {  cena.cena_po_sleve = parseFloat(cena.prodejni_cena) - cena.sleva; computePartials(props.item.produkt, cena); computeTotal(); }"
                            :rules="[ (e) => { return (!isNaN(cena.prodejni_cena) && parseFloat(cena.prodejni_cena) > 0 && parseFloat(cena.prodejni_cena) > parseFloat(cena.vychozi_cena) * 0.75) || 'Cena musí být výšší než ' + parseFloat(cena.vychozi_cena) * 0.75 } ]"
                          ></v-text-field>
                        </p>
                      </td>
                      <td>
                        <v-text-field
                          type="number"
                          class="mt-3 pt-0"
                          v-model="props.item.pocet"
                          reverse
                          :rules="rulesRequiredMoreThanZero"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-right">
                        <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id">
                          <span v-html="computePrice(cena.cena_po_sleve, props.item.pocet)"></span>&nbsp;{{cena.mena.zkratka}}
                        </p>
                      </td>
                      <td class="text-xs-right">{{props.item.sklad.volne | formatInt}} ks</td>
                      <td class="text-xs-right">{{props.item.sklad.blokovano | formatInt}} ks</td>
                      <td class="text-xs-right">{{props.item.sklad.na_ceste | formatInt}} ks</td>
                      <td>
                        <v-layout row>
                          <v-flex>
                            <v-btn color="grey lighten-3" depressed fab small @click="newItems.splice(newItems.indexOf(props.item), 1);computeTotal();"><v-icon>delete</v-icon></v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <tr>
                      <td>Celkem bez DPH:</td>
                      <td colspan="7" class="text-xs-right">
                        {{newItemCelkem.bez_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                      </td>
                    </tr>
                    <tr v-if="newItemCelkem.dph_10>0">
                      <td>DPH 10%</td>
                      <td colspan="7" class="text-xs-right">
                        {{newItemCelkem.dph_10 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                      </td>
                    </tr>
                    <tr v-if="newItemCelkem.dph_15>0">
                      <td>DPH 15%</td>
                      <td colspan="7" class="text-xs-right">
                        {{newItemCelkem.dph_15 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                      </td>
                    </tr>
                    <tr v-if="newItemCelkem.dph_21>0">
                      <td>DPH 21%</td>
                      <td colspan="7" class="text-xs-right">
                        {{newItemCelkem.dph_21 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Celkem s DPH:</strong></td>
                      <td colspan="7" class="text-xs-right">
                        <strong>{{newItemCelkem.s_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span></strong>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="8">
                        <productsearch label="Vyhledat produkt" class="mt-3" @changed="productChanged" :clearOnSelect="true"></productsearch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
              <v-card color="grey lighten-4 mt-3" :class="{'mx-3 mt-4' : $vuetify.breakpoint.smAndUp}">
                <v-textarea
                  label="Poznámka k objednávce"
                  height="60"
                  v-model="newItem.popis"
                ></v-textarea>
              </v-card>
            </v-form>
          </v-card-text>
          <v-divider class="mt-3 mb-3"></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-3 elevation-0" v-if="saveCreate" dark><v-icon small class="mr-2">picture_as_pdf</v-icon>Vygenerovat fakturu</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending" v-if="!editMode"><v-icon class="mr-2">save</v-icon>Vytvořit</v-btn>
            <v-btn color="blue darken-3 elevation-0" dark @click="edit" :loading="sending" v-else><v-icon class="mr-2">save</v-icon>Upravit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="1200px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Detail prodeje</h2>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark class="mr-0" @click="dialogRemove=true" v-if="detailItem.stav=='novy_prodej'"><v-icon small class="mr-2">delete</v-icon>Storno</v-btn>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <p class="grey--text caption mb-1">Datum:</p>
                  <strong>{{detailItem.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <p class="grey--text caption mb-1">Sklad:</p>
                  <strong>{{detailItem.sklad.nazev}}</strong>
                </v-flex>
              </v-layout>
              <v-card color="grey lighten-4 mt-4">
                <h4 class="mx-0">Produkty v objednávce:</h4>
                <v-data-table
                  :headers="detailProduktyHeaders"
                  :items="detailItem.produkty"
                  :pagination.sync="pagination"
                  :total-items="pagination.totalItems"
                  :rows-per-page-items="[25, 50, 100, 200]"
                  class="mt-2"
                  item-key="produkt_id"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</router-link>
                      </td>
                      <td class="text-xs-right">
                        {{props.item.castka_mj | formatPrice}} {{detailItem.mena.zkratka}}
                      </td>
                      <td class="text-xs-right">
                        {{props.item.mnozstvi | formatInt}}
                      </td>
                      <td class="text-xs-right">
                        {{props.item.castka | formatPrice}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                  </template>
                  <template slot="footer">
                    <tr>
                      <td>Celkem bez DPH:</td>
                      <td colspan="5" class="text-xs-right">
                        {{detailItem.castka_celkem_bez_dph | formatMoney}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                    <tr v-if="detailItem.castka_celkem_dph_10>0">
                      <td>DPH 10%</td>
                      <td colspan="5" class="text-xs-right">
                        {{detailItem.castka_celkem_dph_10 | formatMoney}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                    <tr v-if="detailItem.castka_celkem_dph_15>0">
                      <td>DPH 15%</td>
                      <td colspan="5" class="text-xs-right">
                        {{detailItem.castka_celkem_dph_15 | formatMoney}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                    <tr v-if="detailItem.castka_celkem_dph_21>0">
                      <td>DPH 21%</td>
                      <td colspan="5" class="text-xs-right">
                        {{detailItem.castka_celkem_dph_21 | formatMoney}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Celkem s DPH:</strong></td>
                      <td colspan="5" class="text-xs-right">
                        {{detailItem.castka_celkem | formatMoney}} {{detailItem.mena.zkratka}}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-form>
          </v-card-text>
          <v-divider class="mt-3 mb-3"></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-3 elevation-0" dark><v-icon small class="mr-2">picture_as_pdf</v-icon>Faktura</v-btn>
            <v-btn color="blue darken-3 elevation-0" dark><v-icon small class="mr-2">folder_shared</v-icon>Předávací protokol</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="detailItem.stav=='novy_prodej'" @click="editClick" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Drobný prodej</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-right text-md-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Drobný prodej
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                :loading="loadingTable"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatDate }}</td>
                  <td class="text-xs-right">{{ props.item.castka_celkem | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td>{{ props.item.sklad.nazev }}</td>
                  <td>{{ props.item.popis }}</td>
                  <td>
                    <span v-if="props.item.stav=='novy_prodej'">Vytvořeno</span>
                    <span v-else-if="props.item.stav=='fakturovano'">Vyfakturováno</span>
                    <span v-else-if="props.item.stav=='predano'">Předáno</span>
                  </td>
                  <!-- <td class="text-center">
                    <v-btn color="primary" class="elevation-0">
                    <v-icon small class="mr-2">picture_as_pdf</v-icon> Stáhnout</v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn color="primary" class="elevation-0">
                    <v-icon small class="mr-2">picture_as_pdf</v-icon> Stáhnout</v-btn>
                  </td> -->
                  <td class="text-center">
                    <v-btn color="primary" @click="loadItem(props.item.id)" class="elevation-0">
                    <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialogCreate: false,
      dialogDetail: false,
      dialogRemove: false,
      editMode: false,
      updating: false,
      saveCreate: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka_celkem', align: 'right' },
        { text: 'Sklad', value: 'sklad.nazev' },
        { text: 'Popis', value: 'popis' },
        { text: 'Stav', value: 'stav' },
        /*{ text: 'Faktura PDF', value: null, sortable: false, align: 'center' },
        { text: 'Předávací protokol PDF', value: null, sortable: false, align: 'center' },*/
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      items: [],
      newItems: [],
      itemsUhrada: [
        'Hotovost',
        'Elektronická peněženka'
      ],
      newItem: null,
      newItemCelkem: { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 },
      newHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena MJ", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Počet", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Skladem", value: "sklad.volne", sortable: false, width: 150, align: "right" },
        { text: "Blokováno", value: "sklad.blokovano", sortable: false, width: 150, align: "right" },
        { text: "Na cestě", value: "sklad.na_ceste", sortable: false, width: 150, align: "right" },
        { text: "", value: "", sortable: false, width: 60, align: "right" },
      ],
      detailProduktyHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena MJ", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Počet", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem", value: "ceny", sortable: false, width: 150, align: "right" }
      ],
      dialogInit: {
        mena_id: null,
        sklad_id: null,
        popis: null,
        mena: null
      },
      preneseni_dan_povinnost_invalid_1: false,
      preneseni_dan_povinnost_invalid_2: false,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      rulesRequiredMoreThanZero: [
        (v) => !!v && v > 0 || "Pole je vyžadováno"
      ],
      valid: true,
      sending: false,
      loadingTable: false,
      detailItem: null,

    }
  },
  watch: {
    pagination: {
      deep: true,
      handler (v) {
        this.load();
      }
    },
    newItem: {
      deep: true,
      handler (v) {
        this.computeTotal();
      }
    },
    newItems: {
      deep: true,
      handler (v) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        this.computeTotal();
      }
    }
  },
  mounted () {
    this.load();
  },
  methods: {
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("drobny-prodej/search", {
        pagination: this.pagination,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
      this.newItems = [];
      this.editMode = false;
    },
    productChanged (e) {
      if (e != null)
        window.API.get("produkty/" + e.id + "/ceny").then(function(body) {
          body.forEach((e) => {
            e.cena_po_sleve = parseFloat(e.prodejni_cena);
            e.sleva = null;
          });
          var ceny = body;
          window.API.get("drobny-prodej/produkty/" + e.id + "/sklad/" + this.newItem.sklad_id).then(function(body) {
            this.newItems.push({ produkt: e, produkt_id: e.id, pocet: "1", ceny: ceny, sklad: body});
            this.computeTotal();
          }.bind(this)).catch(function(err) {
          }.bind(this));
        }.bind(this)).catch(function(err) {
        }.bind(this));
    },
    computePrice(c, q) {
      if (c == null || q == null || c <= 0 || q <= 0)
        return 0;
      return window.th.formatPrice(c*q, 2, ",", " ").replace(" ", "&nbsp;")
    },
    computeTotal () {
      if (this.newItems != null && this.newItems.length > 0) {
        var mena_id = this.newItem.mena_id;
        this.newItemCelkem.bez_dph = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].prodejni_cena_bez_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_10 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 10 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_15 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 15 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_21 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 21 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.s_dph = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].cena_po_sleve * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; });
        //console.log(this.computingError);
      }
      else {
        this.newItemCelkem = { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 };
      }
    },
    computePartials (p, c, computeTotal) {
      switch (p.zvlastni_rezim) {
        case "neni":
          var dph = parseFloat(c.cena_po_sleve) - (parseFloat(c.cena_po_sleve) / (1 + c.sazba_dph / 100));
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_90":
          var dph = parseFloat(c.cena_po_sleve) >= c.nakladova_cena ? (parseFloat(c.cena_po_sleve) - c.nakladova_cena - ((parseFloat(c.cena_po_sleve) - c.nakladova_cena) / (1 + c.sazba_dph / 100))) : 0;
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_92":
          c.prodejni_cena_dph = 0;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve);
          break;
      }
      if (typeof computeTotal == "undefined" || computeTotal)
        this.computeTotal();
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        /*var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }*/
        if (!this.preneseni_dan_povinnost_invalid_1 && !this.preneseni_dan_povinnost_invalid_2) {
          this.sending = true;
          window.API.post("drobny-prodej", {
            datum: this.newItem.datum_sjednani,
            mena_id: this.newItem.mena_id,
            sklad_id: this.newItem.sklad_id,
            popis: this.newItem.popis,
            produkty: this.newItems.map((e) => {
              return {
                id: e.produkt.id,
                mnozstvi: e.pocet,
                cena: e.ceny.filterOne((i) => {
                  return i.mena.id == mena_id;
                })
              };
            })
          }).then(function(body) {
            if (body.created) {
              this.load();
              this.dialogCreate = false;
              this.loadItem(body.id);
            }
            this.sending = false;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.sending = false;
          }.bind(this));
        }
      }
    },
    loadItem (id) {
      window.API.get("drobny-prodej/" + id).then(function(body) {
        this.detailItem = body;
        this.dialogDetail = true;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    remove () {
      window.API.delete("drobny-prodej/" + this.detailItem.id).then(function(body) {
        this.load(() => {
          this.detailItem = null;
          this.dialogDetail = false;
          this.dialogRemove = false;
        });
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    editClick () {
      this.newItem = {
        id: this.detailItem.id,
        mena_id: this.detailItem.mena.id,
        sklad_id: this.detailItem.sklad.id,
        sklad: this.detailItem.sklad,
        popis: this.detailItem.popis,
        mena: this.detailItem.mena
      };
      this.dialogDetail = false;
      this.dialogCreate = true;
      this.newItems = this.detailItem.produkty.map((e) => {
        e.aktualni_ceny = e.aktualni_ceny.map((c) => {
          if (c.mena.id == this.detailItem.mena.id) {
            c.prodejni_cena = e.castka_mj;
            c.cena_po_sleve = e.castka_mj;
          }
          else {
            c.cena_po_sleve = c.prodejni_cena;
          }
          c.sleva = 0;
          return c;
        });
        var p = {
          cena_po_sleve: e.castka_mj,
          produkt: e.produkt,
          sleva: null,
          produkt_id: e.produkt_id,
          pocet: e.mnozstvi.toString(),
          sklad: e.sklad,
          ceny: e.aktualni_ceny
        };
        this.computePartials(p.produkt, p.ceny.filterOne((c) => { return c.mena.id == this.detailItem.mena.id }), false);
        return p;
      });
      this.editMode = true;
    },
    edit () {
      if (this.$refs.createForm.validate()) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        /*var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }*/
        if (!this.preneseni_dan_povinnost_invalid_1 && !this.preneseni_dan_povinnost_invalid_2) {
          this.sending = true;
          window.API.put("drobny-prodej/" + this.detailItem.id, {
            datum: this.newItem.datum_sjednani,
            mena_id: this.newItem.mena_id,
            sklad_id: this.newItem.sklad_id,
            popis: this.newItem.popis,
            produkty: this.newItems.map((e) => {
              return {
                id: e.produkt.id,
                mnozstvi: e.pocet,
                cena: e.ceny.filterOne((i) => {
                  return i.mena.id == mena_id;
                })
              };
            })
          }).then(function(body) {
            if (body.updated) {
              this.load();
              this.dialogCreate = false;
              this.loadItem(body.id);
            }
            this.sending = false;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.sending = false;
          }.bind(this));
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/VykupProdej/DrobnyProdej.vue